$(function() {
    window.setShareLinks();

    $('.-zoom').each(function () {
        var src = $(this).find('img').attr('data-zoom');
        $(this).zoom({
            url: src,
            on: 'mouseover',
            duration: 50
        });
    });
    
    //select product's color
    var pColor = $('#pColor').filter(':checked').val();
    $('.readColor__val').html(pColor)
    $(':radio[name="pColor"]').change(function () {
        var pColor = $(this).filter(':checked').val();
        var titleColor = $(this).filter(':checked').attr('data-title');
        $('.readColor__val').html(titleColor)

        //go to slide with value
        let ractive = $('.slick-slide[value=' + pColor + ']:not(.slick-cloned)').eq(0);
        let nractive = ractive.attr('data-slick-index');
        $(".readImage__nav").slick('slickGoTo', nractive, true);
    });

    //slider product's images
    slickImg()
    function slickImg() {
        $('.readImage__list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            infinite: true,
            asNavFor: '.readImage__nav'
        });
        $('.readImage__nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.readImage__list',
            dots: false,
            centerMode: false,
            infinite: true,
            focusOnSelect: true
        });
    }
    
    if($('.reviewList').length > 0) {
        $('.reviewCaption').hide();
        $('#form-review').hide();
    }
    
    $( "#btn-first-review" ).click(function() {
        $('.reviewCaption').hide();
        $('.writeReview').hide();
        $('#form-review').show();
    });

    $( ".buttonCancel.reviewBtn" ).click(function() {
        $('#form-review').hide();
        $('.writeReview').show();
        if($('.reviewList').length < 1) {
            $('.reviewCaption').show();
        }
    });

    $('#form-review').validate({
        ignore: null,
        rules: {
            content: {
                required: true,
            },
            hiddenRecaptcha: {
                required: function () {
                    if (grecaptcha.getResponse() == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            hiddenRecaptcha: {
                required: "Please check the box below proceed"
            }
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element);
        },
        errorElement: 'p',
        errorClass: 'formError',
        submitHandler: function (form) {
            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: $(form).serialize(),
                success: function(data) { 
                    $('#form-review')[0].reset();
                    grecaptcha.reset();
                    
                    $('#list-review').html(data);
                    $('html, body').animate({
                        scrollTop: $("#list-review").offset().top
                    }, 1000);
                    setTimeout(function () {
                        $('.alert').fadeOut('slow', function(){
                            $(this).remove();
                        });
                    }, 5000);
                },
                error: function (err) {
                    if (err.status == 422) {
                        $.each(err.responseJSON.errors, function (i, error) {
                            var el = $(document).find('[name="'+ i +'"]');
                            el.after($('<p class="formError">' + error[0] + '</p>'));
                        });

                        setTimeout(function() {
                            $(".formError").remove();
                        }, 2000);
                    }
                }
            });
            return false;
        }
    });
});

window.setWishlist = function(productId, status) {
    if(!productId) {
        window.location = HOST_URL + '/login';
        return false;
    }

    let total = $('#all-wishlist').text(),
        totalWishlistMember = $('#total-wishlist-member').text();
    
    $.ajax({
        type: "POST",
        url: HOST_URL + '/wishlist/' + productId,
        data: {
            status: status,
        },
        success: function(data) {
            if(status == 1) {
                total = parseInt(total + 1);
                totalWishlistMember = parseInt(parseInt(totalWishlistMember) + 1);
            } else {
                total = parseInt(total - 1);
                totalWishlistMember = parseInt(parseInt(totalWishlistMember) - 1);
            }

            $('#all-wishlist').text(total);
            $('#total-wishlist-member').text(totalWishlistMember);
            $('#list-wishlist').html(data);
        }
    });
}